import { ComponentType } from 'react';
import { NewsDetails } from 'src/components/news/news-details/news-details';

export const NewsPostPage: ComponentType = (props: any) => {
  const { id } = props.match.params;

  return <NewsDetails id={id} />;
};
